export default class Project {
    constructor(
        title,
        project_name,
        charge_code,
        description,
        business_context_background,
        client_challenge,
        tam_mandate,
        expected_results_impact,
        start_date,
        end_date,
        status,
        client_id,
        business_units,
        industry_id,
        business_domain_ids,
        digital_solution_id,
        managed_service_id,
        offering_ids,
        photo,
        tracks = [],
        has_multiple_tracks = false,
        tracksCount = 0,
        docs_count=1,
        document_type_ids,
        tags = [],
        secondary_docs_count,
        service_line_ids,
    ) {
        this.title = title;
        this.project_name = project_name;
        this.charge_code = charge_code;
        this.description = description;
        this.business_context_background = business_context_background;
        this.client_challenge = client_challenge;
        this.tam_mandate = tam_mandate;
        this.expected_results_impact = expected_results_impact;
        this.start_date = start_date;
        this.end_date = end_date;
        this.status = status;
        this.client_id = client_id;
        this.business_units = business_units;
        this.business_units_data = {};
        this.industry_id = industry_id;
        this.business_domain_ids = business_domain_ids;
        this.digital_solution_id = digital_solution_id;
        this.managed_service_id = managed_service_id;
        this.offering_ids = offering_ids;
        this.photo = photo;
        this.tracks = tracks;
        this.has_multiple_tracks = has_multiple_tracks;
        this.tracksCount = tracksCount;
        this.docs_count = docs_count;
        this.document_type_ids = document_type_ids;
        this.tags = tags;
        this.secondary_docs_count = secondary_docs_count;
        this.service_line_ids = service_line_ids;
    }
}
